<div class="bary-input-multi-select md-form md-outline">
  <jhi-bary-title *ngIf="title" [title]="title" [tooltip]="tooltip"></jhi-bary-title>
  <mdb-select-2 [outline]="true" [multiple]="true" [placeholder]="placeholder ?? ''" [formControl]="control" [allowClear]="true">
    <mdb-select-all-option>{{ 'components.inputs.multiSelect.selectAll' | translate }}</mdb-select-all-option>
    <mdb-select-option *ngFor="let option of options" [value]="option.value">{{ option.label }}</mdb-select-option>
  </mdb-select-2>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
    <span *ngIf="control.hasError('customMessage')" [jhiTranslate]="control?.errors?.customMessage"></span>
  </mdb-error>
</div>
